export const CURRENT_USER = "RMTC_CURRENT_USER";
export const EMAIL = "RMTC_EMAIL";
export const FULL_NAME = "RMTC_FULL_NAME";
export const ROLES = "RMTC_ROLES";
export const PATRON_ROLE = "RMTC_PATRON_ROLE";
export const PATRON_SUBTYPE = "RMTC_PATRON_SUBTYPE";
